import Vue from "vue";
import Vuex from "vuex";
const firebase = require("../../../firebase.config.js");

Vue.use(Vuex);

const UploadModule = {
  namespaced: true,
  state: {
    mediasToUpload: [],
    mediasUploaded: [],
    uploadInProgress: {},
    coverUploaded: null,
    coverToUpload: null,
    average: 0
  },
  getters: {
    getMediasToUpload(state) {
      return state.mediasToUpload;
    },
    getCoverToUpload(state) {
      return state.coverToUpload;
    },
    getMediasUploaded(state) {
      return state.mediasUploaded;
    },
    getCoverUploaded(state) {
      return state.coverUploaded;
    },
    getUploadInProgress(state) {
      return state.uploadInProgress;
    }
  },
  actions: {
    uploadMedias({ state }, { image, cover = false }) {
      if (image.file) {
        return new Promise((resolve, reject) => {
          let dt = new Date().getTime();
          const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function(c) {
              const r = (dt + Math.random() * 16) % 16 | 0;
              dt = Math.floor(dt / 16);
              return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
            }
          );
          const filename = image.file.name;
          const ext = filename.slice(filename.lastIndexOf("."));
          const storageRef = firebase.storage
            .ref("activities/" + uuid + ext)
            .put(image.file);
          storageRef.on(
            `state_changed`,
            snapshot => {
              this.uploadValue =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              state.uploadInProgress[uuid] = this.uploadValue;
              state.average = Math.trunc(this.uploadValue);
            },
            error => {
              reject(error);
            },
            () => {
              this.uploadValue = 100;
              state.average = Math.trunc(this.uploadValue);
              if (cover) {
                state.coverUploaded = storageRef.snapshot.ref.fullPath;
              } else {
                state.mediasUploaded.push(storageRef.snapshot.ref.fullPath);
              }
              resolve();
            }
          );
        });
      } else {
        if (cover) {
          if(image.fullPath) {
            state.coverUploaded = image.fullPath;
          } else {
            state.coverUploaded = image;
          }
        } else {
          state.mediasUploaded.push(image.fullPath);
        }
      }
    },
    resetUpload({ state }) {
      state.mediasUploaded = [];
      state.coverUploaded = null;
      state.mediasToUpload = [];
      state.coverToUpload = null;
      state.uploadInProgress = {};
    },
    addMediasToUpload({ commit }, medias) {
      commit("SET_MEDIAS_TO_UPLOAD", medias);
    },
    addCoverToUpload({ commit }, media) {
      commit("SET_COVER_TO_UPLOAD", media);
    }
  },
  mutations: {
    SET_MEDIAS_TO_UPLOAD(state, data) {
      state.mediasToUpload = data;
    },
    SET_COVER_TO_UPLOAD(state, data) {
      state.coverToUpload = data;
    }
  }
};

export default UploadModule;
